
import React, { useEffect, useState, useMemo } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { useBusinessFormContext } from '@/context/BusinessFormContext';

interface FormProgressIndicatorProps {
  // Props that FormContent was passing:
  // basicInfoComplete, addressComplete, industryComplete, userDetailsComplete,
  // isSubmitEnabled, progressPercentage
  // These will now come from context.
  onBackButtonClick?: () => void; // Keep if used elsewhere
  showBackButton?: boolean;     // Keep if used elsewhere
}

const FormProgressIndicator: React.FC<FormProgressIndicatorProps> = ({
  // onBackButtonClick, // Not used in the provided FormContent snippet
  // showBackButton,    // Not used in the provided FormContent snippet
}) => {
  const {
    basicInfoEdited,     // Using 'edited' status for progress as per FormContent logic
    addressEdited,
    industryEdited,
    userDetailsComplete, // UserDetails is complete when valid, no separate 'edited' state for saving
    isSubmitEnabled,
  } = useBusinessFormContext();

  const [computedProgress, setComputedProgress] = useState(0);
  
  const completedSteps = useMemo(() => {
    return [
      basicInfoEdited, 
      addressEdited, 
      industryEdited, 
      userDetailsComplete
    ].filter(Boolean).length;
  }, [basicInfoEdited, addressEdited, industryEdited, userDetailsComplete]);

  const totalSteps = 4;

  useEffect(() => {
    const calculatedPercentage = (completedSteps / totalSteps) * 100;
    setComputedProgress(calculatedPercentage);
    
    // console.log("FormProgressIndicator - Updated progress:", {
    //   completedSteps,
    //   calculatedPercentage,
    //   sections: {
    //     basicInfoEdited,
    //     addressEdited,
    //     industryEdited,
    //     userDetailsComplete
    //   }
    // });
  }, [completedSteps, totalSteps]);
  
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-1">
          <span className="text-gray-600 font-medium">Progress:</span>
          <span className="font-semibold hidden md:inline">{completedSteps} of {totalSteps} sections complete</span>
        </div>
        
        {isSubmitEnabled && (
          <span className="flex items-center text-green-600">
            <CheckCircle2 size={16} className="mr-1" />
            Ready to submit
          </span>
        )}
      </div>
      <Progress 
        value={computedProgress} 
        className="h-2" 
        indicatorClassName="bg-[#00d023]" 
      />
    </div>
  );
};

export default FormProgressIndicator;
